/**
 * Variant Selector Modal - Standalone handler
 * Attaches click handlers to .variant-card buttons inside .kraft-variant-modal,
 * manages selection state, and handles add-to-cart on Continue.
 */
(function () {
  'use strict';

  function initializeVariantModal(modal) {
    if (modal.dataset.variantInitialized) return;
    modal.dataset.variantInitialized = 'true';

    var variantCards = modal.querySelectorAll('.variant-card');
    var continueBtn = modal.querySelector('[data-variant-continue-btn]');
    var selectionText = modal.querySelector('[data-variant-selection-text]');
    var selectedVariant = null;

    variantCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (this.disabled || this.classList.contains('variant-card--unavailable')) {
          return;
        }

        variantCards.forEach(function (c) { c.classList.remove('active'); });
        this.classList.add('active');

        selectedVariant = {
          id: this.getAttribute('data-variant-id'),
          price: this.getAttribute('data-variant-price'),
          name: this.getAttribute('data-variant-name')
        };

        if (continueBtn) continueBtn.disabled = false;
        if (selectionText && selectedVariant.name) {
          selectionText.textContent = 'Selected: ' + selectedVariant.name;
        }
      }, true);
    });

    if (continueBtn) {
      continueBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!selectedVariant) return;

        var variantId = selectedVariant.id;

        var sectionId = modal.dataset.sectionId;
        var quantity = 1;
        if (sectionId) {
          var quantityInput = document.querySelector(
            '.product-detail-quantity-input[data-section-id="' + sectionId + '"]'
          );
          if (quantityInput) {
            quantity = parseInt(quantityInput.value, 10) || 1;
          }
        }

        var cartSectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (item) {
          if (item.dataset && item.dataset.sectionId) {
            cartSectionIds.push(item.dataset.sectionId);
          }
        });

        closeVariantModal(modal);

        var fetchBody = {
          id: parseInt(variantId, 10),
          quantity: quantity
        };
        if (cartSectionIds.length) {
          fetchBody.sections = cartSectionIds.join(',');
        }

        // When the modal opts out of booking apps (data-bypass-booking),
        // use the native fetch captured before Cowlendar wraps window.fetch
        // so the product is purchased directly instead of opening the
        // booking calendar.
        var fetchFn = (modal.dataset.bypassBooking === 'true' && window.__nativeFetch)
          ? window.__nativeFetch
          : window.fetch;

        fetchFn.call(window, '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(fetchBody)
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (err) { throw err; });
            return response.json();
          })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: null,
                sourceId: 'variant-selector-modal',
                data: {
                  source: 'variant-selector-modal',
                  sections: data.sections || {}
                }
              }
            }));

            document.dispatchEvent(new CustomEvent('theme:cart:update', {
              detail: { data: data },
              bubbles: true
            }));

            var cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer) {
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                cartDrawer.dispatchEvent(new CustomEvent('open'));
              }
            }
          })
          .catch(function () {
            // Silently handle - Cowlendar/booking apps intercept the fetch
            // and manage their own flow for non-cartable products
          });
      });
    }

    function resetSelection() {
      variantCards.forEach(function (c) { c.classList.remove('active'); });
      if (continueBtn) continueBtn.disabled = true;
      if (selectionText) selectionText.textContent = 'Select a variant to continue';
      selectedVariant = null;
    }

    var classObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (!modal.classList.contains('active')) {
            resetSelection();
            unlockBodyScroll();
          }
        }
      });
    });
    classObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });

    var closeBtn = modal.querySelector('[data-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', resetSelection);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) resetSelection();
    });
  }

  function unlockBodyScroll() {
    document.body.classList.remove('modal-open');
    document.documentElement.classList.remove('modal-open');
  }

  function closeVariantModal(modal) {
    modal.classList.remove('active');
    unlockBodyScroll();
  }

  function ensureInitialized(modal) {
    if (!modal || modal.dataset.variantInitialized) return;
    initializeVariantModal(modal);
  }

  // Auto-initialize any variant modal when it becomes active
  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var target = mutation.target;
        if (target.classList && target.classList.contains('kraft-variant-modal') && target.classList.contains('active')) {
          ensureInitialized(target);
        }
      }
    });
  });

  function observeVariantModals() {
    document.querySelectorAll('.kraft-variant-modal').forEach(function (modal) {
      bodyObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeVariantModals);
  } else {
    observeVariantModals();
  }

  // Also handle dynamically added modals
  new MutationObserver(function (mutations) {
    var shouldReobserve = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (node.classList.contains('kraft-variant-modal') || node.querySelector('.kraft-variant-modal'))) {
          shouldReobserve = true;
        }
      });
    });
    if (shouldReobserve) observeVariantModals();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
